import React from "react";

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#5F6C60]">Legal</div>
      <h1 className="font-serif-display text-4xl sm:text-5xl tracking-tight mt-2">Privacy Policy</h1>
      <p className="text-xs text-[#5F6C60] mt-3">Last updated: February 25, 2026</p>

      <div className="mt-10 max-w-none text-[#2C352D] leading-relaxed space-y-6 text-[15px]">
        <p>Your privacy matters. This policy explains what we collect, how we use it, and your choices.</p>

        <h2 className="font-serif-display text-2xl mt-8">Information we collect</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Account data:</strong> name, email, role (customer/individual therapist/business), business name and phone (providers).</li>
          <li><strong>Deal data:</strong> deal content, photos, pricing, and location you publish as a provider.</li>
          <li><strong>Reviews:</strong> star ratings and comments you leave as a customer.</li>
          <li><strong>Payment data:</strong> handled by Stripe; we store only references (session ID, status) — never card numbers.</li>
          <li><strong>Usage data:</strong> standard server logs (IP, user-agent, timestamps) for security and reliability.</li>
        </ul>

        <h2 className="font-serif-display text-2xl mt-8">How we use it</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>To operate the marketplace — show your deal to customers in your area.</li>
          <li>To process subscription and feature-pin payments through Stripe.</li>
          <li>To send transactional emails (deal approval, trial expiring, password reset).</li>
          <li>To moderate listings and respond to disputes.</li>
        </ul>

        <h2 className="font-serif-display text-2xl mt-8">Sharing</h2>
        <p>We share data only with the processors required to run the service: Stripe (payments), our hosting/database providers, and our email provider. We do not sell personal information.</p>

        <h2 className="font-serif-display text-2xl mt-8">Customer contact details</h2>
        <p>When you submit a "Need a Therapist" request or contact a provider, the provider you contact will see the contact information you choose to share.</p>

        <h2 className="font-serif-display text-2xl mt-8">Cookies</h2>
        <p>We use an HttpOnly session cookie to keep you logged in. We do not use third-party advertising cookies.</p>

        <h2 className="font-serif-display text-2xl mt-8">Data retention</h2>
        <p>Account and deal data are retained while your account is active. You may request deletion of your account by contacting us; we may retain limited records for legal/financial compliance.</p>

        <h2 className="font-serif-display text-2xl mt-8">Your rights</h2>
        <p>Depending on your jurisdiction, you may have rights to access, correct, export, or delete your data. Contact us to exercise these rights.</p>

        <h2 className="font-serif-display text-2xl mt-8">Children</h2>
        <p>Massage Savings is not directed to children under 16. We do not knowingly collect data from children.</p>

        <h2 className="font-serif-display text-2xl mt-8">Contact</h2>
        <p>For privacy questions, email <a href="mailto:privacy@massagesavings.com" className="text-[#D97757] hover:underline">privacy@massagesavings.com</a>.</p>
      </div>
    </div>
  );
}
